import { Segmented } from 'antd'
import { useEffect, useState } from 'react'
import i18next, { type AppLocale } from '../lib/i18n'
import { useSetLanguage } from '../lib/localeController'
import { useI18nEnabled } from '../lib/useI18nEnabled'

const OPTIONS: { label: string; value: AppLocale }[] = [
  { label: 'DE', value: 'de-DE' },
  { label: 'EN', value: 'en-DE' },
]

/**
 * Header DE/EN language toggle. Rendered only when the `enable_english` flag is
 * on (German-only otherwise, no switcher). Writes the preference and drives
 * react-i18next via {@link setAppLanguage}; the LocaleController updates AntD +
 * dayjs off the resulting language change.
 */
export function LanguageSwitcher() {
  const enabled = useI18nEnabled()
  const setLanguage = useSetLanguage()
  const [lng, setLng] = useState<string>(i18next.language)

  useEffect(() => {
    const onChange = (next: string) => setLng(next)
    i18next.on('languageChanged', onChange)
    return () => {
      i18next.off('languageChanged', onChange)
    }
  }, [])

  if (!enabled) return null

  return (
    <Segmented
      size="small"
      value={lng}
      options={OPTIONS}
      onChange={(value) => setLanguage(value as AppLocale)}
      aria-label="Sprache / Language"
    />
  )
}
